import throttle from 'lodash/throttle';
import { get } from 'styleguide/lib/props';
import $ from "jquery";

const $viewPrevLoading = $(".js-view-prev-loading");
const $viewMoreLoading = $(".js-view-more-loading");
const $viewMoreBtn = $(".js-view-more-btn");
const $viewPrevBtn = $(".js-view-prev-btn");
const $plpProductsContents = $("#plp-products-contents");
const $showProductCount = $("#showing-items-count");
let $statusMessage;
let fetchPage;

const isABTest3336 = get('abtests.ab3336', false);

$(() => {
  // Only execute code if test is active on page
  if (isABTest3336 === false) return false;

  let currentPage = parseInt($('.js-plp-prod-wrapper>ul').data('currentPage'));
  let pagesLoaded = { min: currentPage, max: currentPage }
  let isFetching = false;
  let nextPagePromise = null;
  let prevPagePromise = null;
  let nextPageData = null;
  let prevPageData = null;
  let userClickedNextCTABeforeDataLoaded = false;
  let lastScrollTop = 0;

  // Flag for visual search
  let isVisualSearch = !!$('#loadVisNav').val();

  if (isVisualSearch) {
    fetchPage = fetchVisualNavPage;
  } else {
    fetchPage = fetchRegularPage;
  }

  // Any time a plp filter is selected, we want to clear
  // the data that was prefetched
  function pageFilterSelectedClear() {
    console.log('fn() pageFilterSelectedClear');
    nextPagePromise = null;
    prevPagePromise = null;
    nextPageData = null;
    prevPageData = null;
    currentPage = 1;
    pagesLoaded = { min: currentPage, max: currentPage };
    $viewPrevBtn.hide();
  }


  $(document).on("filterSelected", pageFilterSelectedClear);

  $(document).on("visualFilterSelected", function () {
    isVisualSearch = true;
    fetchPage = fetchVisualNavPage;
    pageFilterSelectedClear();
  });

  function updateURL(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('pageNum', page);
    window.history.pushState({}, '', url);
  }

  function updateProductCount() {
    const productCount = $('.js-plp-prod-wrapper').find('li.js-plp-container').length;
    $showProductCount.html(productCount);
  }

  // New function to handle product clicks
  function handleProductClick(e) {
    e.preventDefault();
    const $productLink = $(e.currentTarget);
    const $productItem = $productLink.closest('li'); // Get the parent li element
    const productId = $productItem.attr('id');
    const $parentList = $productItem.closest('ul');
    const currentPage = $parentList.data('currentPage');

    // Use the clicked link's href directly since e.currentTarget is now the link
    const productUrl = $productLink.attr('href');

    // Update URL with both page and product ID
    const url = new URL(window.location.href);
    url.searchParams.set('pageNum', currentPage);
    url.searchParams.set('product', productId);
    window.history.pushState({}, '', url);

    // Navigate to product page
    window.location.href = productUrl;
  }

  // Attach click handler to all product items (existing and future)
  $(document).on('click', '.js-plp-prod-wrapper .js-plp-pdp-link, .js-plp-prod-wrapper .js-plp-pdp-link2', handleProductClick);

  function fetchRegularPage(page) {
    return new Promise((resolve, reject) => {
      const url = new URL(window.location.href);
      url.searchParams.set('pageNum', page);
      const data = $.param({
        url: url.href,
        isMen: $('#isMen').length ? $('#isMen').val() : 'false'
      });
      $.ajax({
        url: '/content/products/filtered-plp-contents/',
        data: data,
        dataType: 'json',
        type: 'POST',
        success: function (data) {
          const $pageData = $(data.plpMarkup);
          resolve($pageData);
        },
        error: function () {
          reject("Error fetching products.");
        }
      });
    });
  }

  function fetchVisualNavPage(page) {
    return new Promise((resolve, reject) => {
      const { url, data } = window.doVisualSearch(page, null, true);

      $.ajax({
        url: url,
        data: data,
        dataType: 'json',
        type: 'GET',
        success: function (data) {
          const $pageData = $(data.searchResultMarkup);
          resolve($pageData);
        },
        error: function () {
          reject("Error fetching products.");
        }
      });
    });
  }

  function preloadNextPage() {
    console.log('fn() preloadNextPage');
    if (isFetching || nextPagePromise) return;

    let nextPage = pagesLoaded.max + 1;
    isFetching = true;

    nextPagePromise = fetchPage(nextPage)
      .then(data => {
        nextPageData = data;
        return data;
      })
      .finally(() => {
        isFetching = false
        if (userClickedNextCTABeforeDataLoaded) displayNextPage();
      });
  }

  function loadPrevPage() {
    console.log('fn() loadPrevPage');
    if (isFetching || prevPagePromise || pagesLoaded.min === 1) return;

    let prevPage = pagesLoaded.min - 1;
    isFetching = true;
    prevPagePromise = fetchPage(prevPage)
      .then(data => {
        prevPageData = data;
        return data;
      })
      .finally(() => {
        isFetching = false;
        displayPrevPage();

        var $element = $('.js-plp-prod-wrapper').first();

        if ($element.length > 0) {
          window.scrollTo({
            top: $element[0].scrollHeight
          });
        }
      });

    // a11y announcement
    $statusMessage.html('page is loading');
  }

  function displayNextPage() {
    if (!nextPagePromise || !nextPageData) return;
    userClickedNextCTABeforeDataLoaded = false;
    $plpProductsContents.append(nextPageData);
    pagesLoaded.max += 1;
    nextPageData = null;
    nextPagePromise = null;

    $viewMoreLoading.addClass('u-hide');
    $viewMoreBtn.removeClass('u-hide');
    window.reloadBindJs && window.reloadBindJs();

    // -----
    // a11y
    // -----

    const $lastSection = $plpProductsContents.find('section').last();

    // Update button CTA aria-label
    const $productList = $lastSection.find(".products-grid");
    const currentPage = $productList.data('currentPage');
    const totalPages = $productList.data('totalPages');
    const containerId = $productList.data('id');
    window.bindHeartItems && bindHeartItems(`#${containerId}`);
    const totalPageCount = parseInt(totalPages);
    if (pagesLoaded.max >= totalPageCount) {
      $viewMoreBtn.addClass('u-hide');
    }
    updateProductCount();

    $viewMoreBtn.attr('aria-label', `Load Next Page (Page ${currentPage + 1} of ${totalPages})`);

    // announcement
    $statusMessage.html('page has loaded');

    // focus on last section
    $lastSection.attr('tabindex', '-1');
    $lastSection[0].focus({ preventScroll: true });

  }

  function displayPrevPage() {
    if (!prevPagePromise || !prevPageData) return;

    pagesLoaded.min -= 1;

    if (pagesLoaded.min > 1) {
      $viewPrevBtn.show();
    }

    $plpProductsContents.prepend(prevPageData);

    $viewPrevLoading.addClass('u-hide');
    prevPageData = null;
    prevPagePromise = null;

    // reinitialize events
    window.reloadBindJs && window.reloadBindJs();

    // -----
    // a11y
    // -----

    const $firstSection = $plpProductsContents.find('section').first();

    // Update button CTA aria-label
    const $productList = $firstSection.find(".products-grid");
    const currentPage = $productList.data('currentPage');
    $viewPrevBtn.attr('aria-label', `Load Previous Page (Page ${currentPage - 1})`);
    updateProductCount();
    // announcement
    $statusMessage.html('page has loaded');


    // focus on first section

    $firstSection.attr('tabindex', '-1')
    $firstSection[0].focus({ preventScroll: true });
  }

  function updateURLBasedOnScroll() {
    const viewportMiddle = window.scrollY + (window.innerHeight / 2);
    const pages = $(".js-plp-prod-wrapper>ul");

    let closestPage = null;
    let closestDistance = Infinity;

    pages.each(function () {
      const pageElement = $(this);
      const pageMiddle = pageElement.offset().top + (pageElement.height() / 2);
      const distance = Math.abs(viewportMiddle - pageMiddle);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestPage = pageElement;
      }
    });

    const pageNumber = closestPage.data('currentPage');
    updateURL(pageNumber);
  }

  // Handle "view more" button click
  $viewMoreBtn.on("click", function () {
    if (nextPagePromise && nextPageData) {
      displayNextPage();
    } else {
      userClickedNextCTABeforeDataLoaded = true;
      $viewMoreBtn.addClass('u-hide');
      $viewMoreLoading.removeClass('u-hide');
    }
    if (typeof window.logEngagement == "function") {
      window.logEngagement(window.location.href, 'View More', 'Click');
    }
  });

  // Handle "Previous" button click
  $viewPrevBtn.on("click", function () {
    if (!isFetching && pagesLoaded.min > 1) {
      $viewPrevBtn.hide();
      $viewPrevLoading.removeClass('u-hide');
      loadPrevPage();
      if (typeof window.logEngagement == "function") {
        window.logEngagement(window.location.href, 'View Previous', 'Click');
      }
    }
  });

  const throttleUpdateURL = throttle(updateURLBasedOnScroll, 100);

  /**
    * onScroll handle preload for "next page"
  **/
  $(window).on("scroll", function () {
    const st = $(window).scrollTop();
    const windowHeight = $(window).height();
    const docHeight = $(document).height();

    throttleUpdateURL();

    const isScrollingDown = st > lastScrollTop;
    lastScrollTop = st;

    // Next Page Preload Logic
    if (isScrollingDown) {
      if (!isFetching && !nextPagePromise) {
        let lastPage = $(".js-plp-prod-wrapper").last();
        let lastPageOffset = lastPage.offset().top + lastPage.outerHeight();
        let triggerPoint = lastPageOffset - (lastPage.outerHeight() * (1 / 3));

        if (st + windowHeight > triggerPoint) {
          preloadNextPage();
        }
      }
    }
  });

  /**
   * Product page navigation enhancement
   * 
   * This script handles the case when a user clicks the back button after viewing a product:
   * 1. Extracts the product ID from URL parameters
   * 2. Removes the product parameter from URL (for cleaner history)
   * 3. Scrolls to the product in the product listing page if it exists
   * 
   * This improves UX by maintaining context when navigating back from product details.
   */
  function setupPageNavigationHandlers() {
    let hasScrolled = false;
    let productId;
    // Handle when returning to the page (including back button)
    $(window).on('pageshow.view-more-cta', scrollToProduct);
    $(document).one('products:loaded', ()=>{
        history.scrollRestoration = 'manual';
        scrollToProduct();
    });


    function scrollToProduct() {
      if (hasScrolled === true) return;
      const url = new URL(window.location.href);
      productId = url.searchParams.get('product') || productId;
      // Clean up URL by removing the product parameter
      if (productId) {
        url.searchParams.delete('product');
        history.replaceState({}, '', url);
      }

      // Handle scroll position restoration
      if (productId && $('#' + productId).length) {
        hasScrolled = true;
        // User came back with a product ID - scroll to that product
        setTimeout(() => {
          $('#' + productId)[0].scrollIntoView({ block: 'center' });
        }, 50);
      }
      // For all other cases (including persisted pages), let the browser handle 
      // scroll restoration naturally - no manual intervention needed
    }
  }

  function appendSRStatusElement() {
    $statusMessage = $(`<div id="view-more-status-message" aria-live="polite" role="status" class="u-screen-reader"></div>`);
    $('body').append($statusMessage);
  }

  appendSRStatusElement();
  setupPageNavigationHandlers();
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/ab-3336-view-more-cta.js